import { Trans, useTranslation } from 'react-i18next';

import CardContent from '@material-ui/core/CardContent';

import Company from '../../../../types/Company';
import logoCertified from '../../assets/logo_certified.jpg';
import logoProgress from '../../assets/logo_progress.jpg';
import { StyledCard, StyledDescription, StyledTitle } from './styled';

interface Props {
    company: Company;
}

const StateCard = (props: Props) => {
    const { company } = props;
    const { certificates } = company;

    const { t } = useTranslation();

    const lastCertificate = certificates.length ? certificates[certificates.length - 1] : null;
    const noCertificate = !lastCertificate;

    const value = lastCertificate && (!lastCertificate.co2Eq ? lastCertificate.co2Eq : (lastCertificate.co2Eq * -1));
    const reducedPlastic = lastCertificate && (!lastCertificate.kgReducedPlastic ? lastCertificate.kgReducedPlastic : (lastCertificate.kgReducedPlastic * -1));

    return (
        <StyledCard variant='outlined'>
            <CardContent style={{ height: '100%' }}>
                <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                    <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500, textAlign: noCertificate ? 'center' : 'left' }}>
                        {t('pages.dashboard.cards.state.title')}
                    </StyledTitle>

                    <div style={noCertificate ? { flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } : undefined}>
                        <img alt='Plastic Free Certification logo' src={(lastCertificate && !lastCertificate.isExpired) ? logoCertified : logoProgress} style={{ maxWidth: '100%', maxHeight: '180px' }} />
                    </div>

                    {(lastCertificate && !lastCertificate.isExpired) && (
                        <>
                            <div style={{ flexGrow: 1 }} />

                            <StyledDescription style={{ marginTop: '6px' }}>
                                Grade {lastCertificate?.grade}
                            </StyledDescription>

                            {(lastCertificate.kgReducedPlastic !== null || lastCertificate.co2Eq !== null) && (
                                <StyledDescription style={{ marginTop: '6px', marginBottom: '-12px' }}>
                                    {lastCertificate.kgReducedPlastic !== null && (
                                        <Trans i18nKey='pages.dashboard.cards.grade.kg_reduced_plastic' tOptions={{ value: reducedPlastic }}>
                                            _<strong>{reducedPlastic}</strong>_
                                        </Trans>
                                    )}

                                    {(lastCertificate.kgReducedPlastic !== null && lastCertificate.co2Eq !== null) && <br />}

                                    {lastCertificate.co2Eq !== null && (<Trans i18nKey='pages.dashboard.cards.grade.co2_saving' tOptions={{ value }}>
                                        _<strong>{value}</strong>_
                                    </Trans>)}
                                </StyledDescription>
                            )}
                        </>
                    )}
                </div>


            </CardContent>
        </StyledCard>
    );
};

export default StateCard;
